import { User } from '@app/core/models';
import { Action, createReducer, on } from '@ngrx/store';
import * as Actions from './message.actions';
import { contactAdapter } from './message.adapters';
import { selectContactId } from './message.adapters';
import { initialState, State } from './message.state';
import { NewChatRecipient } from '@app/core/async-services/http/versioned/interfaces/chat.interface';
import { Contact } from '@app/core/models/chat.interface';

const messageReducer = createReducer(
  initialState,
  on(Actions.loadContactsSuccess, (state, { response }) => ({
    ...state,
    contacts: contactAdapter.setAll(
      response.payload.availablePeople,
      state.contacts,
    ),
  })),
  on(Actions.addRecipient, (state, { contact }) => ({
    ...state,
    recipients: [
      ...(state.recipients as NewChatRecipient[]),
      state.contacts.entities[
        selectContactId({
          userID: contact.id,
          userType: contact.isManager ? User.Type.MANAGER : User.Type.EMPLOYEE,
        })
      ] as Contact,
    ],
  })),
  on(Actions.removeRecipient, (state, { index }) => ({
    ...state,
    recipients: [
      ...state.recipients.slice(0, index),
      ...state.recipients.slice(index + 1),
    ],
  })),
  on(Actions.clearRecipients, (state) => ({
    ...state,
    recipients: [],
  })),
  on(Actions.getChatChannelForUsersSuccessChannelExists, (state) => ({
    ...state,
    recipients: [],
  })),
  on(Actions.addPeopleToChat, (state, { currentRecipients }) => {
    const recipients = currentRecipients
      .filter((recipient) => recipient.canReceiveMessages)
      .map((recipient) => ({
        userID: recipient.userID,
        userType: recipient.userType,
        firstName: recipient.firstName,
        lastName: recipient.lastName,
      }));
    return { ...state, recipients };
  }),
  on(Actions.sendFirstMessageSuccess, (state) => ({
    ...state,
    recipients: [],
  })),
);

export function reducer(state: State | undefined, action: Action) {
  return messageReducer(state, action);
}
